import { GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { CommunityRulesState } from './types';

export const getters: GetterTree<CommunityRulesState, RootState> = {
  //
};
